import { useState } from "react";
import type { CartItem } from "../../../contexts/CartContext";

const CITIES = [
  "台北市", "新北市", "桃園市", "台中市", "台南市", "高雄市",
  "基隆市", "新竹市", "嘉義市", "新竹縣", "苗栗縣", "彰化縣",
  "南投縣", "雲林縣", "嘉義縣", "屏東縣", "宜蘭縣", "花蓮縣",
  "台東縣", "澎湖縣", "金門縣", "連江縣",
];

const DISTRICTS: Record<string, string[]> = {
  "台北市": ["中正區", "大同區", "中山區", "松山區", "大安區", "萬華區", "信義區", "士林區", "北投區", "內湖區", "南港區", "文山區"],
  "新北市": ["板橋區", "三重區", "中和區", "永和區", "新莊區", "新店區", "樹林區", "鶯歌區", "三峽區", "淡水區", "汐止區", "瑞芳區", "土城區", "蘆洲區", "泰山區", "林口區", "深坑區", "石碇區", "坪林區", "烏來區"],
  "桃園市": ["桃園區", "中壢區", "平鎮區", "八德區", "楊梅區", "蘆竹區", "大溪區", "龍潭區", "龜山區", "大園區", "觀音區", "新屋區", "復興區"],
  "台中市": ["中區", "東區", "南區", "西區", "北區", "西屯區", "南屯區", "北屯區", "豐原區", "大里區", "太平區", "清水區", "沙鹿區", "梧棲區", "烏日區", "大甲區", "大肚區", "龍井區", "霧峰區", "東勢區", "潭子區", "神岡區"],
  "台南市": ["中西區", "東區", "南區", "北區", "安平區", "安南區", "永康區", "歸仁區", "新化區", "左鎮區", "玉井區", "南化區", "仁德區", "關廟區", "龍崎區", "官田區", "麻豆區", "佳里區", "西港區", "七股區", "將軍區", "學甲區", "北門區", "新營區", "後壁區", "白河區", "東山區", "六甲區", "下營區", "柳營區", "鹽水區", "善化區", "大內區", "山上區", "新市區", "安定區"],
  "高雄市": ["新興區", "前金區", "苓雅區", "鹽埕區", "鼓山區", "旗津區", "前鎮區", "三民區", "楠梓區", "小港區", "左營區", "仁武區", "大社區", "岡山區", "路竹區", "阿蓮區", "田寮區", "燕巢區", "橋頭區", "梓官區", "彌陀區", "永安區", "湖內區", "鳳山區", "大寮區", "林園區", "鳥松區", "大樹區", "旗山區", "美濃區", "六龜區", "內門區", "杉林區", "甲仙區", "桃源區", "那瑪夏區", "茂林區", "茄萣區"],
  "基隆市": ["仁愛區", "信義區", "中正區", "中山區", "安樂區", "暖暖區", "七堵區"],
  "新竹市": ["東區", "北區", "香山區"],
  "嘉義市": ["東區", "西區"],
  "新竹縣": ["竹北市", "湖口鄉", "新豐鄉", "新埔鎮", "關西鎮", "芎林鄉", "寶山鄉", "竹東鎮", "五峰鄉", "橫山鄉", "尖石鄉", "北埔鄉", "峨眉鄉"],
  "苗栗縣": ["苗栗市", "苑裡鎮", "通霄鎮", "竹南鎮", "頭份市", "後龍鎮", "卓蘭鎮", "大湖鄉", "公館鄉", "銅鑼鄉", "南庄鄉", "頭屋鄉", "三義鄉", "西湖鄉", "造橋鄉", "三灣鄉", "獅潭鄉", "泰安鄉"],
  "彰化縣": ["彰化市", "鹿港鎮", "和美鎮", "線西鄉", "伸港鄉", "福興鄉", "秀水鄉", "花壇鄉", "芬園鄉", "員林市", "溪湖鎮", "田中鎮", "大村鄉", "埔鹽鄉", "埔心鄉", "永靖鄉", "社頭鄉", "二水鄉", "北斗鎮", "二林鎮", "田尾鄉", "埤頭鄉", "芳苑鄉", "大城鄉", "竹塘鄉", "溪州鄉"],
  "南投縣": ["南投市", "中寮鄉", "草屯鎮", "國姓鄉", "埔里鎮", "仁愛鄉", "名間鄉", "集集鎮", "水里鄉", "魚池鄉", "信義鄉", "竹山鎮", "鹿谷鄉"],
  "雲林縣": ["斗南鎮", "大埤鄉", "虎尾鎮", "土庫鎮", "褒忠鄉", "東勢鄉", "臺西鄉", "崙背鄉", "麥寮鄉", "斗六市", "林內鄉", "古坑鄉", "莿桐鄉", "西螺鎮", "二崙鄉", "北港鎮", "水林鄉", "口湖鄉", "四湖鄉", "元長鄉"],
  "嘉義縣": ["番路鄉", "梅山鄉", "竹崎鄉", "阿里山鄉", "中埔鄉", "大埔鄉", "水上鄉", "鹿草鄉", "太保市", "朴子市", "布袋鎮", "大林鎮", "民雄鄉", "溪口鄉", "新港鄉", "六腳鄉", "東石鄉", "義竹鄉"],
  "屏東縣": ["屏東市", "三地門鄉", "霧台鄉", "瑪家鄉", "九如鄉", "里港鄉", "高樹鄉", "鹽埔鄉", "長治鄉", "麟洛鄉", "竹田鄉", "內埔鄉", "萬丹鄉", "潮州鎮", "泰武鄉", "來義鄉", "萬巒鄉", "崁頂鄉", "新埤鄉", "南州鄉", "林邊鄉", "東港鎮", "琉球鄉", "車城鄉", "滿州鄉", "枋寮鄉", "新園鄉", "枋山鄉", "春日鄉", "獅子鄉", "牡丹鄉", "恆春鎮", "佳冬鄉"],
  "宜蘭縣": ["宜蘭市", "頭城鎮", "礁溪鄉", "壯圍鄉", "員山鄉", "羅東鎮", "三星鄉", "大同鄉", "五結鄉", "冬山鄉", "蘇澳鎮", "南澳鄉"],
  "花蓮縣": ["花蓮市", "新城鄉", "秀林鄉", "吉安鄉", "壽豐鄉", "鳳林鎮", "光復鄉", "豐濱鄉", "瑞穗鄉", "萬榮鄉", "玉里鎮", "卓溪鄉", "富里鄉"],
  "台東縣": ["台東市", "綠島鄉", "蘭嶼鄉", "延平鄉", "卑南鄉", "鹿野鄉", "關山鎮", "海端鄉", "池上鄉", "東河鄉", "成功鎮", "長濱鄉", "太麻里鄉", "金峰鄉", "大武鄉", "達仁鄉"],
  "澎湖縣": ["馬公市", "西嶼鄉", "望安鄉", "七美鄉", "白沙鄉", "湖西鄉"],
  "金門縣": ["金城鎮", "金湖鎮", "金沙鎮", "金寧鄉", "烈嶼鄉", "烏坵鄉"],
  "連江縣": ["南竿鄉", "北竿鄉", "莒光鄉", "東引鄉"],
};

interface CheckoutFormProps {
  items: CartItem[];
  totalPrice: number;
  onSuccess: (data: {
    name: string;
    phone: string;
    city: string;
    district: string;
    address: string;
    totalPrice: number;
  }) => void;
}

export default function CheckoutForm({ items, totalPrice, onSuccess }: CheckoutFormProps) {
  const [city, setCity] = useState("");
  const [district, setDistrict] = useState("");
  const [charCount, setCharCount] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState<Record<string, string>>({});

  const availableDistricts = city && DISTRICTS[city] ? DISTRICTS[city] : [];

  const handleCityChange = (v: string) => {
    setCity(v);
    setDistrict("");
  };

  const validate = (form: HTMLFormElement) => {
    const data = new FormData(form);
    const errs: Record<string, string> = {};
    if (!data.get("name")) errs.name = "請輸入姓名";
    if (!data.get("phone")) errs.phone = "請輸入手機";
    if (!city) errs.city = "請選擇縣市";
    if (!district) errs.district = "請選擇鄉鎮";
    if (!data.get("address")) errs.address = "請輸入地址";
    return errs;
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const errs = validate(form);
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }
    setErrors({});
    setSubmitting(true);

    const formData = new FormData(form);
    formData.set("city", city);
    formData.set("district", district);
    formData.set("orderItems", items.map((i) => `${i.product.name} x${i.quantity}`).join("; "));
    formData.set("totalPrice", `NT$ ${totalPrice.toLocaleString()}`);

    const body = new URLSearchParams();
    formData.forEach((val, key) => body.append(key, String(val)));

    try {
      await fetch("https://readdy.ai/api/form/d75a3nr41deorl02f810", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
    } catch {
      // ignore
    } finally {
      setSubmitting(false);
    }

    onSuccess({
      name: String(formData.get("name") ?? ""),
      phone: String(formData.get("phone") ?? ""),
      city,
      district,
      address: String(formData.get("address") ?? ""),
      totalPrice,
    });
  };

  const inputBase = "w-full h-12 px-4 bg-white border rounded-sm text-sm text-[#1B4332] placeholder:text-zinc-400 focus:outline-none focus:border-[#1B4332] transition-colors duration-200";

  return (
    <form
      data-readdy-form
      onSubmit={handleSubmit}
      className="space-y-8"
    >
      {/* Section: 收件資訊 */}
      <div>
        <h2 className="text-lg font-semibold text-[#1B4332] mb-6 flex items-center gap-3">
          <span className="w-7 h-7 flex items-center justify-center bg-[#1B4332] text-white text-xs font-bold rounded-full">1</span>
          收件資訊
        </h2>
        <div className="space-y-4">
          {/* Name + Phone */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-xs text-zinc-500 mb-1.5">姓名 *</label>
              <input
                name="name"
                type="text"
                placeholder="請輸入真實姓名"
                className={`${inputBase} ${errors.name ? "border-red-400" : "border-zinc-200"}`}
              />
              {errors.name && <p className="text-red-400 text-xs mt-1">{errors.name}</p>}
            </div>
            <div>
              <label className="block text-xs text-zinc-500 mb-1.5">手機號碼 *</label>
              <input
                name="phone"
                type="tel"
                placeholder="09XX-XXX-XXX"
                className={`${inputBase} ${errors.phone ? "border-red-400" : "border-zinc-200"}`}
              />
              {errors.phone && <p className="text-red-400 text-xs mt-1">{errors.phone}</p>}
            </div>
          </div>

          {/* Email */}
          <div>
            <label className="block text-xs text-zinc-500 mb-1.5">電子郵件</label>
            <input
              name="email"
              type="email"
              placeholder="your@email.com"
              className={`${inputBase} border-zinc-200`}
            />
          </div>

          {/* City + District */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-xs text-zinc-500 mb-1.5">縣市 *</label>
              <div className="relative">
                <select
                  value={city}
                  onChange={(e) => handleCityChange(e.target.value)}
                  className={`${inputBase} pr-10 appearance-none cursor-pointer ${errors.city ? "border-red-400" : "border-zinc-200"}`}
                >
                  <option value="">請選擇縣市</option>
                  {CITIES.map((c) => (
                    <option key={c} value={c}>{c}</option>
                  ))}
                </select>
                <i className="ri-arrow-down-s-line absolute right-3 top-1/2 -translate-y-1/2 text-zinc-400 pointer-events-none"></i>
              </div>
              {errors.city && <p className="text-red-400 text-xs mt-1">{errors.city}</p>}
            </div>
            <div>
              <label className="block text-xs text-zinc-500 mb-1.5">鄉鎮市區 *</label>
              <div className="relative">
                <select
                  value={district}
                  onChange={(e) => setDistrict(e.target.value)}
                  disabled={!city}
                  className={`${inputBase} pr-10 appearance-none cursor-pointer disabled:opacity-50 ${errors.district ? "border-red-400" : "border-zinc-200"}`}
                >
                  <option value="">請選擇鄉鎮</option>
                  {availableDistricts.map((d) => (
                    <option key={d} value={d}>{d}</option>
                  ))}
                </select>
                <i className="ri-arrow-down-s-line absolute right-3 top-1/2 -translate-y-1/2 text-zinc-400 pointer-events-none"></i>
              </div>
              {errors.district && <p className="text-red-400 text-xs mt-1">{errors.district}</p>}
            </div>
          </div>

          {/* Address */}
          <div>
            <label className="block text-xs text-zinc-500 mb-1.5">詳細地址 *</label>
            <input
              name="address"
              type="text"
              placeholder="請輸入路段、號碼"
              className={`${inputBase} ${errors.address ? "border-red-400" : "border-zinc-200"}`}
            />
            {errors.address && <p className="text-red-400 text-xs mt-1">{errors.address}</p>}
          </div>

          {/* Note */}
          <div>
            <label className="block text-xs text-zinc-500 mb-1.5">備註（選填）</label>
            <div className="relative">
              <textarea
                name="note"
                placeholder="例如：請放在門口、週末配送..."
                maxLength={500}
                rows={3}
                onChange={(e) => setCharCount(e.target.value.length)}
                className="w-full px-4 py-3 bg-white border border-zinc-200 rounded-sm text-sm text-[#1B4332] placeholder:text-zinc-400 focus:outline-none focus:border-[#1B4332] transition-colors duration-200 resize-none"
              />
              <span className="absolute bottom-2 right-3 text-[11px] text-zinc-400">{charCount}/500</span>
            </div>
          </div>
        </div>
      </div>



      {/* Submit */}
      <button
        type="submit"
        disabled={submitting}
        className="w-full h-14 flex items-center justify-center bg-[#1B4332] text-white text-sm font-medium tracking-widest hover:bg-zinc-700 transition-colors duration-200 rounded-sm disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
      >
        {submitting ? (
          <span className="flex items-center gap-2">
            <i className="ri-loader-4-line animate-spin text-base"></i>
            處理中...
          </span>
        ) : (
          "確認下單"
        )}
      </button>

      <p className="text-center text-zinc-400 text-xs flex items-center justify-center gap-1.5">
        <i className="ri-lock-line text-sm"></i>
        您的資料經過加密保護
      </p>
    </form>
  );
}
